import { useParams, Link } from 'react-router-dom';
import SEO from '@/components/base/SEO';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Breadcrumb from '@/components/base/Breadcrumb';
import CategoryTabs from '@/components/feature/CategoryTabs';
import ArticleCard from '@/components/feature/ArticleCard';
import { categories, categoryMap } from '@/mocks/categories';
import { articlesByCategory } from '@/mocks/articles';

const baseUrl = 'https://haosexiaoyi.com';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = slug ? categoryMap[slug] : undefined;
  const catArticles = slug ? (articlesByCategory[slug] || []) : [];

  if (!category) {
    return (
      <>
        <SEO
          title="分类未找到"
          description="抱歉，您查找的分类页面不存在。请浏览我们的其他精彩内容。"
          keywords="好色小姨,都市言情,分类页面"
          canonicalUrl={`${baseUrl}/category/${slug || ''}`}
        />
        <Navbar />
        <main className="min-h-screen flex items-center justify-center pt-16 bg-background-50">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-foreground-950 mb-4">分类未找到</h1>
            <p className="text-foreground-600 mb-6">抱歉，您查找的分类页面不存在。</p>
            <Link to="/" className="text-primary-500 hover:text-primary-600 font-medium">
              返回首页
            </Link>
          </div>
        </main>
        <Footer />
        <ScrollToTop />
      </>
    );
  }

  const schema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'CollectionPage',
        name: `${category.name} - 好色小姨故事集`,
        description: category.description,
        url: `${baseUrl}/category/${slug}`,
        isPartOf: {
          '@type': 'WebSite',
          name: '好色小姨故事集',
          url: baseUrl,
        },
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: baseUrl },
          { '@type': 'ListItem', position: 2, name: category.name, item: `${baseUrl}/category/${slug}` },
        ],
      },
    ],
  };

  return (
    <>
      <SEO
        title={category.name}
        description={category.description}
        keywords={`${category.name},好色小姨,都市言情小说,家庭伦理故事,经典小说人物,情感故事`}
        canonicalUrl={`${baseUrl}/category/${slug}`}
        schema={schema}
      />
      <Navbar />
      <main className="pt-20 pb-14 md:pb-20 bg-background-50 min-h-screen">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', href: '/' },
              { label: category.name },
            ]}
          />

          <div className="mb-10">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 rounded-xl flex items-center justify-center bg-accent-100/70 text-accent-500">
                <i className={`${category.icon} text-lg`}></i>
              </div>
              <h1 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                {category.name}
              </h1>
            </div>
            <p className="text-sm text-foreground-600 max-w-2xl">{category.description}</p>
          </div>

          <div className="mb-8">
            <CategoryTabs categories={categories} activeSlug={slug} />
          </div>

          {catArticles.length > 0 ? (
            <div className="space-y-5">
              {catArticles.map((article) => (
                <ArticleCard key={article.slug} article={article} variant="default" />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <p className="text-foreground-500">该分类暂无文章</p>
            </div>
          )}
        </div>
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}